import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import prefrence from "../../assets/images/rsicons/prefrence.png"

//import Lead from "./Lead";
import ClientLink from "./client-link";
import { getClientDetail, addClientImportantDate, addClientChild, getClientImportantDate, getClientChild, deleteClientImportant, updateClientProfile} from "../../store/clients/actions"
import Switch from "react-switch"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import {  isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import ClientSidebar from "components/VerticalLayout/ClientSidebar";

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  Collapse
} from "reactstrap"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios"
import SaveButton from "components/buttons/save";
import ClientProfileBreadcrumbs from "components/Common/ClientProfileBreadcrumb";
import ClientProfileMenu from "./menu/client-profile-menu";
import PhoneInputField from "components/dropdowns/PhoneInputField";
import LineBreadcrumbs from "components/Common/LineBreadcrumb";
import { API_URL } from "helpers/app_url";
import SafeField from "helpers/SafeField";
class ClientSecProfile extends Component {
  constructor(props) {
    super(props)
    this.state = {
   
      secProfile : ''
    }
      
  }


componentDidMount() {
  const { match: { params }, onGetClientDetail} = this.props;
  onGetClientDetail(params.clientId);
  this.fetchSecProfile();
}
fetchSecProfile(){
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;
  const headers = {
      Authorization: `Bearer ${token}`, 
      "Content-Type": "application/json",
    };
    axios
    .get(`${API_URL}ClientContactExt/get_client_secondary_contact_ext_by_clientid/${this.props.match.params.id}`, { headers })
    .then((response) => {
    
      this.setState({ secProfile: response.data,  loading: false });
    })
    .catch((error) => {
      this.setState({ error: error.message, loading: false });
    });
}
 handleSubmit = (values, { setSubmitting, resetForm }) => {
     const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
        Authorization: `Bearer ${token}`, 
        "Content-Type": "application/json",
      };
      toast.loading('Please wait.....')
    const payload = {
        id: values.id,
          clientId: values.clientId,
          agentId:values.agentId,
          contactFName: values.contactFName,
          contactLName: values.contactLName,
          cContactId:values.cContactId,
          organization:values.organization,
          jobTitle:values.jobTitle,
          industry:values.industry,
          email:values.email,
          mobile:values.mobile,
          office:values.office,
          phoneExt:values.phoneExt
        };
    axios
      .put(`${API_URL}ClientContactExt/update_clientext_secondary_contact`, payload, { headers })
      .then((response) => {
        if(response.data?.success){
            toast.dismiss();
            toast.success('Updated successfully.');
        }else{
           toast.dismiss();
            toast.error('some error.');
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };
  render() {
    const { clietDetail, isResponsive } = this.props;
    const{ secProfile } = this.state;
   

    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
         <div className="loading">Loading&#8230;</div>
         ) : null}
        <ToastContainer autoClose={2000} />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Client Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
         
            <Row>
              <Col sm='2' className="pe-0">
                <ClientSidebar id={this.props.match.params.id} clientId={this.props.match.params.clientId} clientDetail={clietDetail} isResponsive={isResponsive} />
              </Col>
              <Col sm='10' className="">
               <Row className="project-header">
                            <Col sm='7'>
                         <LineBreadcrumbs
                          title={this.props.t("Clients")}
                          breadcrumbItem={this.props.t(  " Dashboard")}
                        />
                        </Col>
                        <Col sm="4" className="">
                            <h2 className="">{this.props.t( clietDetail.firstName + " " + clietDetail.lastName)}</h2>
                            </Col>
                        </Row>
            <ClientProfileMenu isResponsive={isResponsive} />
            <Row>
              
              
              <Col xl="12">
            
              <Card className="border-full">
                          <CardBody>
                          <Formik
                        enableReinitialize={true}
                        initialValues={{
                          id: secProfile?.id,
                          clientContactId:secProfile?.clientContactId,
                          clientId: secProfile?.clientId,
                  
                          contactFName: secProfile?.contactFName || '',
                          contactLName: secProfile?.contactLName || '',
                          cContactId:secProfile?.cContact?.id,
                          organization:secProfile?.organization,
                          jobTitle:secProfile?.jobTitle,
                          industry:secProfile?.industry,
                          email:secProfile?.cContact?.email || '',
                          mobile:secProfile?.cContact?.mobile,
                          office:secProfile?.cContact?.office,
                          phoneExt:secProfile?.cContact?.phoneExt
                        }}
                        validationSchema={Yup.object().shape({
                          contactFName : Yup.string().required("This is Required"),
                          contactLName : Yup.string().required("This is Required"),
                          email : Yup.string().email('Enter valid emai').required("This is Required"),  
                        })}

                        onSubmit={this.handleSubmit}
                      >
                        {({ errors, touched, values, handleChange, setFieldValue }) => (

                          <Form
                            className="needs-validation"
                          >

{/* <h5 className="card-title">Secondary Contact Details</h5> */}
              
              <Row>
                 

                   <Col sm="3">
                   <FormGroup className="mb-3">
                       <Label htmlFor="contactFName">
                         {this.props.t("First Name *")}
                       </Label>
                       <SafeField
                         name="contactFName"
                         onChange={handleChange}                            
                         type="text"
                         
                         className={
                           "form-control" +
                           (errors.contactFName && touched.contactFName
                             ? " is-invalid"
                             : "")
                         }
                        
                         id="contactFName"
                       />
                        <ErrorMessage
                         name="contactFName"
                         component="div"
                         className="invalid-feedback"
                       />
                     </FormGroup>
                   </Col>
                   <Col sm="3">
                   <FormGroup className="mb-3">
                       <Label htmlFor="contactLName">
                         {this.props.t("Last Name *")}
                       </Label>
                       <SafeField
                         name="contactLName"
                         onChange={handleChange}                            
                         type="text"
                         
                         className={
                           "form-control" +
                           (errors.contactLName && touched.contactLName
                             ? " is-invalid"
                             : "")
                         }
                        
                         id="contactLName"
                       />
                        <ErrorMessage
                         name="contactLName"
                         component="div"
                         className="invalid-feedback"
                       />
                     </FormGroup>
                   </Col>     
                   <Col sm="3">
                     <PhoneInputField
                          label="Mobile"
                          name="mobile"
                          value={values.mobile}
                          setFieldValue={setFieldValue}
                          error={errors.mobile}
                          touched={touched.mobile}
                          country="ca"
                          required={false}
                        />
                  
                   </Col>
             
                   <Col sm="3">
                   <FormGroup className="mb-3">
                       <Label htmlFor="email">
                         {this.props.t("Email *")}
                       </Label>
                       <SafeField
                         name="email"
                         onChange={handleChange}                            
                         type="text"
                         
                         className={
                           "form-control" +
                           (errors.email && touched.email
                             ? " is-invalid"
                             : "")
                         }
                        
                         id="email"
                       />
                        <ErrorMessage
                         name="email"
                         component="div"
                         className="invalid-feedback"
                       />
                     </FormGroup>

                       </Col>

            
                   </Row>
                      
                       <Row>
                       <Col sm="3">
                       <FormGroup className="mb-3">
                       <Label htmlFor="organization">
                         {this.props.t("Company Name")}
                       </Label>
                       <SafeField
                         name="organization"
                         onChange={handleChange}                            
                         type="text"
                         
                         className={
                           "form-control" +
                           (errors.organization && touched.organization
                             ? " is-invalid"
                             : "")
                         }
                        
                         id="organization"
                       />
                        <ErrorMessage
                         name="organization"
                         component="div"
                         className="invalid-feedback"
                       />
                     </FormGroup>

                       </Col>

                       <Col sm="3">
                       <FormGroup className="mb-3">
                       <Label htmlFor="jobTitle">
                         {this.props.t("Job Title")}
                       </Label>
                       <SafeField
                         name="jobTitle"
                         onChange={handleChange}                            
                         type="text"
                         
                         className={
                           "form-control" +
                           (errors.jobTitle && touched.jobTitle
                             ? " is-invalid"
                             : "")
                         }
                        
                         id="jobTitle"
                       />
                        <ErrorMessage
                         name="jobTitle"
                         component="div"
                         className="invalid-feedback"
                       />
                     </FormGroup>

                       </Col>

                       <Col sm="2">
                        <PhoneInputField
                          label="Office Phone"
                          name="office"
                          value={values.office}
                          setFieldValue={setFieldValue}
                          error={errors.office}
                          touched={touched.office}
                          country="ca"
                          required={false}
                        />
                   

                       </Col>
                       <Col sm="1">
                       <FormGroup className="mb-3">
                       <Label htmlFor="phoneExt">
                         {this.props.t("Ext")}
                       </Label>
                       <SafeField
                         name="phoneExt"
                         onChange={handleChange}                            
                         type="text"
                         
                         className={
                           "form-control" +
                           (errors.phoneExt && touched.phoneExt
                             ? " is-invalid"
                             : "")
                         }
                        
                         id="phoneExt"
                       />
                        <ErrorMessage
                         name="phoneExt"
                         component="div"
                         className="invalid-feedback"
                       />
                     </FormGroup>

                       </Col>

                       <Col sm="3">
                       <FormGroup className="mb-3">
                       <Label htmlFor="industry">
                         {this.props.t("Industry")}
                       </Label>
                       <SafeField
                         name="industry"
                         onChange={handleChange}                            
                         type="text"
                         
                         className={
                           "form-control" +
                           (errors.industry && touched.industry
                             ? " is-invalid"
                             : "")
                         }
                        
                         id="industry"
                       />
                        <ErrorMessage
                         name="industry"
                         component="div"
                         className="invalid-feedback"
                       />
                     </FormGroup>

                       </Col>
                       <div className="clearfix"><SaveButton>Save</SaveButton></div>

                       </Row>
                            </Form>
                           )}
                           </Formik>
                      
                          </CardBody>
                        </Card>


            
            </Col>
            
            </Row>
            </Col>
            </Row>
      
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
ClientSecProfile.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object,
  match: PropTypes.object,
  onGetClientDetail:PropTypes.func,
  clietDetail: PropTypes.object,
  loading:PropTypes.object,
  isResponsive:PropTypes.object

}
const mapStateToProps = ({ Clients }) => (
  {
    loading: Clients.loading,
    clietDetail: Clients.clietDetail
  })
const mapDispatchToProps = dispatch => ({
  onGetClientDetail: clientId => dispatch(getClientDetail(clientId)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ClientSecProfile))
